import React, { useState } from "react";
import { MapPin, GraduationCap, Award, ArrowRight, X, ExternalLink } from "lucide-react";
import { successStories } from "@/data/successStories";
import { SectionTitle } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function SuccessStories() {
  const [active, setActive] = useState(null);
  const s = active;

  return (
    <div className="space-y-6">
      <SectionTitle title="Kisah Sukses" desc="Belajar dari perjalanan nyata penerima beasiswa." />

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {successStories.map((st) => (
          <div key={st.id} data-testid={`story-${st.id}`} className="flex flex-col rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-3">
              <img src={st.avatar} alt={st.name} loading="lazy" className="h-16 w-16 rounded-2xl object-cover" />
              <div>
                <p className="font-display text-sm font-bold text-slate-900">{st.name}</p>
                <p className="text-xs text-[#7C3AED]">{st.scholarship}</p>
              </div>
            </div>
            <ul className="mt-4 space-y-1.5 text-xs text-slate-500">
              <li className="flex items-start gap-1.5"><GraduationCap className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#A78BFA]" /> {st.university}</li>
              <li className="flex items-start gap-1.5"><Award className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#A78BFA]" /> {st.program}</li>
              <li className="flex items-start gap-1.5"><MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#A78BFA]" /> {st.country}</li>
            </ul>
            <p className="mt-3 line-clamp-3 text-sm text-slate-600">{st.story}</p>
            <div className="mt-auto pt-4">
              <Button variant="outline" onClick={() => setActive(st)} data-testid={`read-story-${st.id}`} className="w-full rounded-full border-purple-200 text-[#5B21B6] hover:bg-purple-50">Baca Kisah <ArrowRight className="ml-1 h-4 w-4" /></Button>
            </div>
          </div>
        ))}
      </div>

      {s && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" onClick={() => setActive(null)} />
          <div className="relative max-h-[85vh] w-full max-w-xl overflow-y-auto rounded-3xl bg-white p-6 shadow-2xl" data-testid="story-modal">
            <button onClick={() => setActive(null)} className="absolute right-4 top-4 rounded-lg p-1.5 text-slate-400 hover:bg-slate-100"><X className="h-5 w-5" /></button>
            <div className="flex items-center gap-4">
              <img src={s.avatar} alt={s.name} className="h-20 w-20 rounded-2xl object-cover" />
              <div>
                <h2 className="font-display text-xl font-extrabold text-slate-900">{s.name}</h2>
                <p className="text-sm text-[#7C3AED]">{s.scholarship} · {s.university}</p>
              </div>
            </div>
            <ul className="mt-5 space-y-2 text-sm text-slate-600">
              <li className="flex items-start gap-2"><GraduationCap className="mt-0.5 h-4 w-4 shrink-0 text-[#A78BFA]" /> {s.program}</li>
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#A78BFA]" /> {s.country}</li>
            </ul>
            <p className="mt-4 text-sm leading-relaxed text-slate-700">{s.story}</p>
            <a href={s.sourceUrl} target="_blank" rel="noopener noreferrer" data-testid={`source-${s.id}`}
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#7C3AED] hover:underline">
              <ExternalLink className="h-4 w-4" /> {s.source}
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
